'use client'

import { useEffect, useState } from 'react'
import { BoldIcon, ItalicIcon, StrikethroughIcon, UnderlineIcon } from 'lucide-react'
import { useEditorContext } from '@/components/ui/editor'
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip'
import { Button } from '@/components/ui/button'

const FontStyle = () => {
  const { editor, sourceMode } = useEditorContext()

  const [selectionStates, setSelectionStates] = useState({
    bold: false,
    italic: false,
    underline: false,
    strike: false
  })

  useEffect(() => {
    if (!editor) {
      return
    }

    const updateSelection = () => {
      setSelectionStates({
        bold: editor.isActive('bold'),
        italic: editor.isActive('italic'),
        underline: editor.isActive('underline'),
        strike: editor.isActive('strike')
      })
    }

    editor.on('selectionUpdate', updateSelection)
    editor.on('transaction', updateSelection)

    // cleanup
    return () => {
      editor.off('selectionUpdate', updateSelection)
      editor.off('transaction', updateSelection)
    }
  }, [editor])

  return (
    <div className="flex items-center gap-1">
      <Tooltip>
        <TooltipTrigger asChild>
          <Button
            type="button"
            size="sm"
            variant={selectionStates.bold ? 'default' : 'ghost'}
            onClick={() => editor.chain().focus().toggleBold().run()}
            disabled={sourceMode}
            tabIndex={-1}>
            <BoldIcon />
          </Button>
        </TooltipTrigger>
        <TooltipContent>
          <p>Bold</p>
        </TooltipContent>
      </Tooltip>

      <Tooltip>
        <TooltipTrigger asChild>
          <Button
            type="button"
            size="sm"
            variant={selectionStates.italic ? 'default' : 'ghost'}
            onClick={() => editor.chain().focus().toggleItalic().run()}
            disabled={sourceMode}
            tabIndex={-1}>
            <ItalicIcon />
          </Button>
        </TooltipTrigger>
        <TooltipContent>
          <p>Italic</p>
        </TooltipContent>
      </Tooltip>

      <Tooltip>
        <TooltipTrigger asChild>
          <Button
            type="button"
            size="sm"
            variant={selectionStates.underline ? 'default' : 'ghost'}
            onClick={() => editor.chain().focus().toggleUnderline().run()}
            disabled={sourceMode}
            tabIndex={-1}>
            <UnderlineIcon />
          </Button>
        </TooltipTrigger>
        <TooltipContent>
          <p>Underline</p>
        </TooltipContent>
      </Tooltip>

      <Tooltip>
        <TooltipTrigger asChild>
          <Button
            type="button"
            size="sm"
            variant={selectionStates.strike ? 'default' : 'ghost'}
            onClick={() => editor.chain().focus().toggleStrike().run()}
            disabled={sourceMode}
            tabIndex={-1}>
            <StrikethroughIcon />
          </Button>
        </TooltipTrigger>
        <TooltipContent>
          <p>Strikethrough</p>
        </TooltipContent>
      </Tooltip>
    </div>
  )
}

export default FontStyle
